module.exports = __webpack_public_path__ + "static/img/work-cell-u-shaped.86a79a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/work-cell-u-shaped.png
// module id = +Aw7
// module chunks = 1